/* 4U Back in Stock capture
 * Shows an email signup in place of the sold-out button when the selected
 * variant is out of stock. Each signup:
 *   1. subscribes the email to Klaviyo list "VIP LIST No.1" (RNxvxb)
 *   2. registers a Klaviyo back-in-stock alert for that exact variant
 */
(function () {
  if (window.__fuNotifyInit) return;
  window.__fuNotifyInit = true;

  var KLAVIYO_PUBLIC_KEY = 'VQrNsa';
  var VIP_LIST_ID = 'RNxvxb';
  var REVISION = '2025-01-15';
  var SOURCE = 'Back in Stock - Product Page';
  var STORE_KEY = 'fuNotifySubscribed';

  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function writeStore(variantId) {
    try { var s = readStore(); s[variantId] = Date.now(); localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function getVariants(panel) {
    if (panel.__fuVariants) return panel.__fuVariants;
    try {
      panel.__fuVariants = JSON.parse(panel.querySelector('[data-fu-variants]').textContent);
    } catch (e) { panel.__fuVariants = []; }
    return panel.__fuVariants;
  }

  function currentVariantId(panel) {
    var form = document.getElementById(panel.dataset.formId);
    var input = form && form.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    var fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) return String(fromUrl);
    return null;
  }

  function findVariant(panel, id) {
    var list = getVariants(panel);
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
    return null;
  }

  function stickyForm() {
    return document.querySelector('product-sticky-form, .product-sticky-form');
  }

  function ensureStickyButton(panel) {
    var sticky = stickyForm();
    if (!sticky || sticky.querySelector('.fu-sticky-notify')) return;
    var submit = sticky.querySelector('button[type="submit"][name="add"]');
    if (!submit) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--primary fu-sticky-notify';
    btn.innerHTML = '<span class="btn-fill" data-fill></span><span class="btn-text">Notify Me</span>';
    btn.addEventListener('click', function () {
      var p = document.querySelector('[data-fu-notify]:not([hidden])') || panel;
      p.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var input = p.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 450);
    });
    submit.parentNode.insertBefore(btn, submit.nextSibling);
  }

  function render(panel) {
    var id = currentVariantId(panel);
    var variant = id && findVariant(panel, id);
    if (!variant) return;
    var oos = !variant.available;
    var wrapper = panel.closest('.product-form-wrapper');

    if (panel.__fuLastId === variant.id && panel.__fuLastOos === oos) return;
    panel.__fuLastId = variant.id;
    panel.__fuLastOos = oos;

    panel.hidden = !oos;
    if (wrapper) wrapper.classList.toggle('fu-oos', oos);

    var sticky = stickyForm();
    if (sticky) {
      ensureStickyButton(panel);
      sticky.classList.toggle('fu-oos', oos);
    }

    if (!oos) return;

    panel.querySelectorAll('[data-fu-size]').forEach(function (el) { el.textContent = variant.size; });
    panel.querySelectorAll('[data-fu-variant-label]').forEach(function (el) { el.textContent = variant.title; });

    var done = !!readStore()[variant.id];
    showState(panel, 'form');
    if (done) showState(panel, 'success');
    var err = panel.querySelector('[data-fu-error]');
    if (err) err.hidden = true;
  }

  function showState(panel, name) {
    panel.querySelectorAll('[data-fu-state]').forEach(function (el) {
      el.hidden = el.dataset.fuState !== name;
    });
    syncHeight(panel);
  }

  // Match the email field + success pill to the theme's button height at every breakpoint
  function syncHeight(panel) {
    var btn = panel.querySelector('[data-fu-submit]');
    var h = btn && btn.offsetHeight;
    if (!h) return;
    panel.querySelectorAll('.fu-notify__input, .fu-notify__done').forEach(function (el) { el.style.height = h + 'px'; });
  }

  function renderAll() {
    document.querySelectorAll('[data-fu-notify]').forEach(render);
  }

  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': REVISION
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error(path + ' ' + res.status);
      return res;
    });
  }

  function subscribeToVip(email, panel, variant) {
    return post('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: SOURCE,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                properties: {
                  'Back in Stock Product': panel.dataset.productTitle,
                  'Back in Stock Variant': variant.title,
                  'Back in Stock Size': variant.size
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: VIP_LIST_ID } } }
      }
    });
  }

  function subscribeToBackInStock(email, variant) {
    return post('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant.id } }
        }
      }
    });
  }

  function onSubmit(e) {
    var form = e.target.closest('[data-fu-form]');
    if (!form) return;
    e.preventDefault();
    var panel = form.closest('[data-fu-notify]');
    var input = form.querySelector('input[type="email"]');
    var err = form.querySelector('[data-fu-error]');
    var btn = form.querySelector('[data-fu-submit]');
    var email = (input.value || '').trim();
    var variant = findVariant(panel, currentVariantId(panel));

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      err.textContent = 'Enter a valid email so we can reach you.';
      err.hidden = false;
      input.classList.add('is-invalid');
      input.focus();
      return;
    }
    if (!variant) return;

    err.hidden = true;
    input.classList.remove('is-invalid');
    btn.setAttribute('aria-busy', 'true');

    var vip = subscribeToVip(email, panel, variant);
    var bis = subscribeToBackInStock(email, variant).catch(function (e2) {
      if (window.console) console.warn('[4U notify] back-in-stock alert failed', e2);
    });

    Promise.all([vip, bis]).then(function () {
      writeStore(variant.id);
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e3) {}
      syncHeight(panel);
      showState(panel, 'success');
    }).catch(function () {
      err.textContent = 'Something went wrong. Try again in a sec.';
      err.hidden = false;
    }).then(function () {
      btn.removeAttribute('aria-busy');
    });
  }

  function init() {
    renderAll();
    document.addEventListener('submit', onSubmit, true);
    // Re-check after any option change (theme updates the variant input async)
    document.addEventListener('change', function () {
      setTimeout(renderAll, 60);
      setTimeout(renderAll, 400);
    }, true);
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && theme.pubsub.PUB_SUB_EVENTS.variantChange) {
      try { theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function () { setTimeout(renderAll, 0); }); } catch (e) {}
    }
    window.addEventListener('popstate', renderAll);
    window.addEventListener('resize', function () { document.querySelectorAll('[data-fu-notify]').forEach(syncHeight); });
    document.addEventListener('shopify:section:load', renderAll);
    // Light safety net for any path that changes the variant without a change event
    setInterval(renderAll, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
